import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2BreakdownErrorsParams,
  IIndirectTaxFilingV2BreakdownErrorsResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

/**
 * GET /api/v1/new-sales-tax/filings-v2/:filingId/tax-breakdown/errors
 *
 * Every invoice attached to a filing whose tax breakdown FAILED, each paired
 * with its latest calculation error — the detail behind a breakdown row's
 * `totalBreakdownsFailed` count. One-shot fetch (no SWR caching); the Job
 * Errors modal calls this on open.
 */
export async function getIndirectTaxFilingV2BreakdownErrors({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2BreakdownErrorsParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2BreakdownErrorsResponse>
> {
  try {
    const query = new URLSearchParams({
      corporationId: String(params.corporationId),
    });
    const response = await fetcher(
      `new-sales-tax/filings-v2/${params.filingId}/tax-breakdown/errors?${query.toString()}`,
      { method: 'GET' },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to fetch tax breakdown errors',
      };
    }
    return {
      success: true,
      data: json as IIndirectTaxFilingV2BreakdownErrorsResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to fetch tax breakdown errors',
    };
  }
}
